import React from 'react';

/**
 * Pantalla para un usuario que figura en el padrón de productores pero está
 * inactivo (dado de baja en el SGC). No tiene acceso a ningún dato: solo puede
 * cerrar sesión.
 */
const ProductorInactivoScreen = ({ productor, onSignOut }) => (
    <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1A283E, #0D1A29)',
        fontFamily: "'Roboto', sans-serif",
    }}>
        <div style={{
            background: '#ffffff',
            borderRadius: '16px',
            padding: '2rem',
            width: '100%',
            maxWidth: '30rem',
            margin: '0 1rem',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
            textAlign: 'center',
        }}>
            <img
                src="/logo-axon.png"
                alt="Axon Capital"
                style={{ height: '56px', width: 'auto', margin: '0 auto 1rem', display: 'block', objectFit: 'contain' }}
            />
            <h1 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: '1.4rem', color: '#1A283E', marginBottom: '0.75rem' }}>
                Acceso de productor inactivo
            </h1>
            <p style={{ color: '#374151', fontSize: '0.95rem', lineHeight: 1.5, margin: '0 0 0.5rem 0' }}>
                {productor?.nombre ? `${productor.nombre}, tu` : 'Tu'} usuario figura como productor pero no tiene
                acceso activo a la Planilla de Operaciones.
            </p>
            <p style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: 1.5, margin: '0 0 1.5rem 0' }}>
                Contactá a Axon Capital para revisar tu alta en el Sistema de Gestión Comercial.
            </p>
            <button
                onClick={onSignOut}
                style={{
                    background: '#1A283E',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '0.75rem 1.5rem',
                    fontSize: '0.95rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                }}
            >
                Cerrar sesión
            </button>
        </div>
    </div>
);

export default ProductorInactivoScreen;
